<template>
  <div>
    <div></div>
    <div class="sideBarMenu">
      <v-card class="mx-auto" width="300" :color="logoBackground" light>
        <v-toolbar extended :color="toolbarColor" max-height="50">
          <v-toolbar-title
            ><img
              src="@/assets/loyalty-hub-logo.png"
              height="40px"
              style="background-size: cover"
          /></v-toolbar-title>
        </v-toolbar>
        <v-list>
          <v-list-item link @click="link('/admin/dashboard', '')">
            <v-list-item-icon>
              <v-icon :color="iconColor">mdi-home</v-icon>
            </v-list-item-icon>

            <v-list-item-title>หน้าแรก</v-list-item-title>
          </v-list-item>

          <v-list-group
            v-for="item in items"
            :key="item.title"
            v-model="item.active"
            :prepend-icon="item.icon"
            no-action
            :color="iconColor"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="child in item.items"
              :key="child.title"
              link
              @click="link(child.action, child.title)"
              :class="active == child.title ? 'active-menu' : ''"
            >
              <v-list-item-icon>
                <v-icon :color="iconColor">{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-text="child.title"
                  class="text-left"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-card>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { menuList, shopMenuList } from "./sideMenu";
export default {
  name: "AppSideBar",
  data() {
    return {
      items: [],
      iconColor: "#ffffff",
      logoBackground: "#353334",
      toolbarColor: "#800108", //menu: this.items[0].menu,
      //submenu: this.items[0].submenu
      active: "",
    };
  },
  computed: {},
  mounted() {
    if (sessionStorage.getItem("userType") == "Shop") {
      this.items = shopMenuList;
    } else {
      this.items = menuList;
    }
  },
  methods: {
    link(moveto, title) {
      //console.log(moveto);
      this.active = title;
      this.$router.push(moveto);
    },
  },
};
</script>
<style scoped>
.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 20px;
  background-color: #221f20;
  white-space: "pre-line";
}
.v-list-group__header.v-list-item.v-list-item--active.v-list-item--link.theme--light,
.v-list-group.v-list-group--active.v-list-group--no-action {
  background-color: #221f20;
  white-space: "pre-line";
}

.active-menu {
  border: 2px solid #ffffff;
  border-radius: 15px;
}

/*
        #221F20
*/
.sidebar-home {
  background-color: #800108;
  text-align: left;
  color: #ffffff;
}
</style>
